export * from "./ac-expo.queries";
export * from "./accounting.queries";
export * from "./activities.queries";
export * from "./auth.queries";
export * from "./badges.queries";
export * from "./bank-details.queries";
export * from "./basket.queries";
export * from "./business-sector.queries";
export * from "./cash-register.queries";
export * from "./chatbot.queries";
export * from "./collaborator.queries";
export * from "./communication-kit.queries";
export * from "./commercialisation.queries";
export * from "./consent.queries";
export * from "./conversations.queries";
export * from "./credit-note.queries";
export * from "./custom-calendar.queries";
export * from "./custom-pdf-appearance-template.queries";
export * from "./discount-codes.queries";
export * from "./double-authentification.queries";
export * from "./emails-consents";
export * from "./email-deliveries.queries";
export * from "./equipments.queries";
export * from "./event-documents.queries";
export * from "./event-form-answers.queries";
export * from "./event-form-questions.queries";
export * from "./event-gates.queries";
export * from "./event-structure.queries";
export * from "./events";
export * from "./events.queries";
export * from "./exhibitor-commercial.queries";
export * from "./exhibitor-inspector.queries";
export * from "./faq-chatbox.queries";
export * from "./faq.queries";
export * from "./file.queries";
export * from "./global-report.queries";
export * from "./group.queries";
export * from "./guest-checkout.queries";
export * from "./maintenance.queries";
export * from "./nf525.queries";
export * from "./notification.queries";
export * from "./orders.queries";
export * from "./organiser-handle-structure.queries";
export * from "./organiser.queries";
export * from "./payment-history.queries";
export * from "./pdf-jobs.queries";
export * from "./places.queries";
export * from "./posters.queries";
export * from "./potential-duplicate-events.queries";
export * from "./prestations.queries";
export * from "./product.queries";
export * from "./reporting.queries";
export * from "./rights.queries";
export * from "./role.queries";
export * from "./seo.queries";
export * from "./statistics.queries";
export * from "./structure-documents.queries";
export * from "./structure.queries";
export * from "./tickets.queries";
export * from "./touristic-places.queries";
export * from "./user.queries";
